import { render } from "./ClipboardPlusOutline.vue?vue&type=template&id=7bf6c84e"
import script from "./ClipboardPlusOutline.vue?vue&type=script&lang=js"
export * from "./ClipboardPlusOutline.vue?vue&type=script&lang=js"

import exportComponent from "../../vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"@apostrophecms/vue-material-design-icons/ClipboardPlusOutline.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "7bf6c84e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('7bf6c84e', __exports__)) {
    api.reload('7bf6c84e', __exports__)
  }
  
  module.hot.accept("./ClipboardPlusOutline.vue?vue&type=template&id=7bf6c84e", () => {
    api.rerender('7bf6c84e', render)
  })

}


export default __exports__